/**
 * ATC Price Updater
 * - Shows "ADD TO CART — $XX.XX" in the submit button
 * - Updates price on variant change via PUB_SUB_EVENTS.variantChange
 * - Patches ProductForm.toggleSubmitButton so the price is preserved
 *   when the theme re-enables the button after a variant switch
 */
(function () {

  // ── Money formatting ──────────────────────────────────────────
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // ── Inject / update price inside a button ────────────────────
  function injectPrice(btn, price) {
    var span = btn.querySelector('span:not(.loading__spinner):not(.sold-out-message)');
    if (!span) return;

    // Remove any existing price nodes we added
    var existing = span.querySelector('.atc-price-wrap');
    if (existing) existing.remove();

    if (price == null) return; // sold out / unavailable — no price shown

    var wrap = document.createElement('span');
    wrap.className = 'atc-price-wrap';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = ' &mdash; <span class="atc-price" data-atc-price>' + formatMoney(price) + '</span>';
    span.appendChild(wrap);
  }

  // ── Find the ATC button for a section ────────────────────────
  function getBtn(sectionId) {
    return document.getElementById('ProductSubmitButton-' + sectionId);
  }

  // ── Handle variant change event ───────────────────────────────
  function onVariantChange(event) {
    var data      = event && event.data;
    var variant   = data && data.variant;
    var sectionId = data && data.sectionId;
    if (!sectionId) return;

    var btn = getBtn(sectionId);
    if (!btn) return;

    // Store price on the button so the toggleSubmitButton patch can read it
    if (variant && variant.available) {
      btn.dataset.currentPrice = variant.price;
    } else {
      delete btn.dataset.currentPrice;
    }

    injectPrice(btn, variant && variant.available ? variant.price : null);
  }

  // ── Patch ProductForm.toggleSubmitButton ──────────────────────
  // The theme calls toggleSubmitButton(false) after a variant change,
  // which sets submitButtonText.textContent = variantStrings.addToCart
  // — this wipes out our price span. We patch the prototype to re-inject
  // the price immediately after the original method runs.
  function patchProductForm() {
    if (!customElements.get('product-form')) {
      setTimeout(patchProductForm, 50);
      return;
    }

    var ProductFormClass = customElements.get('product-form');
    var originalToggle   = ProductFormClass.prototype.toggleSubmitButton;

    ProductFormClass.prototype.toggleSubmitButton = function (disable, text) {
      originalToggle.call(this, disable, text);

      // After re-enabling, re-inject the price if we have one stored
      if (!disable) {
        var btn = this.submitButton;
        if (btn && btn.dataset.currentPrice) {
          injectPrice(btn, parseInt(btn.dataset.currentPrice, 10));
        }
      }
    };
  }

  // ── Initialise on page load ───────────────────────────────────
  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 50);
      return;
    }

    // Set initial price on all ATC buttons from the data-current-price
    // attribute we'll rely on, or from the button's existing [data-atc-price]
    document.querySelectorAll('[data-atc-price]').forEach(function (priceEl) {
      var btn = priceEl.closest('[type="submit"]');
      if (btn && priceEl.textContent) {
        // Already rendered by Liquid — wrap it properly
        var price = btn.querySelector('.atc-price-wrap');
        if (!price) {
          // Liquid rendered the separator + price as plain text siblings;
          // leave them as-is on first load, just store the raw price
          var rawText = priceEl.textContent.trim();
          // Store a numeric value if possible (not critical for first load)
        }
      }
    });

    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);

    patchProductForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
